import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css, cx } from '@bd/bdui-styles/emotion';
import AccordionToggle from '../../components/AccordionToggle';
import { colors } from '../../styles';

const styles = css`
  color: #FFFFFF;
  position: relative;
  .SectionBuilder_descriptionHead{
    text-align: center;
  }
  .SectionBuilder_descriptionHead {
    display: none;
    @media (min-width: 768px) {
      display: block;
      margin-bottom: 0.4em;
    }
  }
  .SectionBuilder_descWrapper {
    @media (min-width: 992px) {
      &::after {
        content: '';
        display: table;
        clear: both;
      }
    }
  }
  .SectionBuilder_description {
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0.022353em;
    line-height: 1.941176;
    margin: 10px 0 0 0;
    text-align: center;
    @media (min-width: 768px) {
      font-size: 16px;
      margin-top: 20px;
    }
    @media (min-width: 992px) {
      font-size: 17px;
    }
  }
  .SectionBuilder_wrapper{
    padding: 20px;
    background-color: white;
    color: ${colors.color4};
    text-align: center;
    width: 100%;
    margin: 5px 0;
    @media(min-width: 768px){
      width: calc(100% - 10px);
      margin: 0 5px;
    }
  }
  .SectionBuilder_name{
    font-weight: bold;
    font-size: 18px;
  }
  .SectionBuilder_phone{
    font-size: 14px;
    letter-spacing: 0.61px;
  }
  .SectionBuilder_site{
    font-weight: bold;
    letter-spacing: 1.34px;
    font-size: 12px;
  }
  .Underdog_custom{
    position: relative;
    margin-bottom: 10px;
    padding-bottom: 5px;
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 75px;
      height: 2px;
      left: 50%;
      background-color: ${colors.color1};
      transform: translateX(-50%);
    }
    @media(min-width: 992px) {
      margin-bottom:10px;
      padding-bottom: 10px;
      &::after {
        width: 75px;
      }
    }
  }
  .toggler{
    position: absolute;
    top:-140px;
  }
`;

function SectionBuilders({ className, community, builder, widget }) {
  return (
    <div className={cx(styles, className)}>
      <AccordionToggle
        openOnId="approved_builders"
        button="Preferred Builders"
      >
        <span
          className="toggler"
          id="approved_builders"
        />
        <div className="SectionBuilder_descriptionSection">
          <h2 className="CommunityDetail_sectionHead SectionBuilder_descriptionHead GoldText">Preferred Builders</h2>
          <div className="SectionBuilder_descWrapper d-flex flex-column flex-lg-row justify-content-center">
            {
              get(community, 'approved_builders') &&
              <div>
                {get(community, 'approved_builders').map(item => (
                  <div key={item._id} className="SectionBuilder_wrapper">
                    <h3 className="SectionBuilder_name Underdog_custom">{widget.builder.filter(build => build._id === item.builder)[0].name || ''}</h3>
                    {
                      widget.builder.filter(build => build._id === item.builder)[0].phone_number &&
                      <h5 className="SectionBuilder_phone">
                        {widget.builder.filter(build => build._id === item.builder)[0].phone_number}
                      </h5>
                    }
                    {
                      widget.builder.filter(build => build._id === item.builder)[0].website &&
                      <p className="SectionBuilder_site mb-0"><a href={`${widget.builder.filter(build => build._id === item.builder)[0].website}`}>VISIT WEBSITE</a></p>
                    }
                  </div>
                ))}
              </div>
            }
          </div>
          <p className="SectionBuilder_description">If you have your own builder call Forest Ridge at <a href={`tel:${builder.telephone}`}>{builder.telephone}</a> to discuss details.</p>
        </div>
      </AccordionToggle>
    </div>
  );
}

SectionBuilders.propTypes = {
  className: PropTypes.string,
  community: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

SectionBuilders.defaultProps = {
  className: undefined,
};

export default withData({
  builder: true,
  widget: 'approved_builders',
},
)(SectionBuilders);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/SectionBuilders.js